<template>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <rect x="1.5" y="1.5" width="37" height="37" rx="18.5" fill="#EBF0FC"/>
        <rect x="1.5" y="1.5" width="37" height="37" rx="18.5" stroke="white" stroke-width="3"/>
        <path d="M21.1667 18.8333L25.25 14.75M25.25 14.75H21.75M25.25 14.75V18.25M18.8333 21.1667L14.75 25.25M14.75 25.25H18.25M14.75 25.25L14.75 21.75" stroke="#184495" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
export default {
    name: 'IconZoomMini',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
